import { RichTextEditor as MantineRichTextEditor, RichTextEditorControlProps } from "@mantine/tiptap";
import clsx from "clsx";
import { FunctionComponent } from "react";
import styles from "../rich-text-editor.module.scss";
import { faListUl } from "@fortawesome/pro-solid-svg-icons";
import { Icon } from "../../icon";
import { useEditorDisabled } from "../use-editor-disabled";

const BulletListIcon = () => <Icon icon={faListUl} size="xs" />;

export const BulletList: FunctionComponent<RichTextEditorControlProps> = ({ className, disabled, ...other }) => {
    const effectiveDisabled = useEditorDisabled(disabled);
    return (
        <MantineRichTextEditor.BulletList
            className={clsx(styles["control"], className)}
            disabled={effectiveDisabled}
            {...other}
            icon={BulletListIcon}
        />
    );
};

BulletList.displayName = "RichTextEditor.BulletList";
